import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { OffersModify } from './components/OffersModify';
import { useAdminOffers } from '../../../context/Admins/AdminOffersContext';

import Pagination from "../../../utilities/Pagination";
import OffersampleImg from "../../../assets/defaults/OffersSample.jpg";
import { AddOffersData } from './components/AddOffersData';

export function SettingOffers() {
    const [currentPage, setCurrentPage] = useState(1);
    // const [selectedService, setSelectedService] = useState("");
    const { settingOffers } = useAdminOffers();

    const totalPages = settingOffers?.data?.paginationInfo.totalPagesCount;

    const OffersAdmin = ({ offerId, offerImgAlt, offerImage, OfferNameAr, offerNameEn, startDate, endDate, originalPrice, discountedPrice, isAvailable, descriptionAr, descriptionEn }) => (
        <div className="admin-profile-img col-12 col-md-4 position-relative" >
            {!isAvailable ? <FontAwesomeIcon icon={faBan} className="fs-1 position-absolute top-50 start-50 translate-middle text-warning text-opacity-50 bg-white w-75 h-100 bg-opacity-50 rounded w-100"
                data-bs-toggle="modal"
                data-bs-target={`#Offer_${offerId}`} /> : ""}
            <img
                crossOrigin="anonymous"
                src={offerImage ? offerImage : OffersampleImg}
                alt={offerImgAlt}
                className="rounded-2 w-100"
                data-bs-toggle="modal"
                data-bs-target={`#Offer_${offerId}`}
            />
            <p className='position-absolute bottom-0 start-50 mb-4 p-1 translate-middle-x bg-white w-75 text-center rounded'>{OfferNameAr}</p>
            <OffersModify
                offerId={offerId}
                offerImgAlt={offerImgAlt}
                offerImage={offerImage}
                OfferNameAr={OfferNameAr}
                offerNameEn={offerNameEn}
                startDate={startDate}
                endDate={endDate}
                originalPrice={originalPrice}
                discountedPrice={discountedPrice}
                isAvailable={isAvailable}
                descriptionAr={descriptionEn}
                descriptionEn={descriptionAr}
                OffersampleImg={OffersampleImg}
            />
        </div>
    );

    if (!settingOffers) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (<>
        <div className="container my-3 rounded bg-light-gray position-relative p-3 pb-4">
            <div className="btn-masar text-center rounded-2 bg-white m-2 mt-0 fs-3 p-0 c-darkGray col-2 float-end"
                data-bs-toggle="modal"
                data-bs-target="#add-AdminOffers">
                +
            </div>
            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                {settingOffers?.result.map((data) => (
                    <OffersAdmin
                        key={data.id}
                        offerId={data.id}
                        OfferNameAr={data.nameAr}
                        offerNameEn={data.nameEn}
                        descriptionAr={data.descriptionAr}
                        descriptionEn={data.descriptionEn}
                        offerImgAlt={`Service_${data.id}`}
                        offerImage={data.image}
                        serviceCreatedAt={data.createdAt}
                        isAvailable={data.isAvailable}
                        startDate={data.startDate}
                        endDate={data.endDate}
                        originalPrice={data.originalPrice}
                        discountedPrice={data.discountedPrice}
                    />
                ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }

        </div>
        <AddOffersData />
    </>)
}